import React from "react";

const Footer = () => {
  return (
    <>
      <div className="shane_tm_section">
        <div className="shane_tm_copyright">
          <div className="container">
            <div className="inner">
              <p style={{ fontFamily: "IBM Plex Sans"}}>
                &copy; {new Date().getFullYear()}{" "}
                Rachel Golden. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
